// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__OOTW0","modalOverlay":"Modal_modalOverlay__AE0dI","modal":"Modal_modal__9tktJ","tomatoStarburst":"Modal_tomatoStarburst__P8G+0"};